function initNewLandingVideoTabsSlider(root) {
  if (typeof Swiper === 'undefined') return;

  var scope = root && root.querySelectorAll ? root : document;
  var sections = scope.querySelectorAll('[data-video-tabs-section]');

  sections.forEach(function (section) {
    if (section.dataset.videoTabsInitialized) return;
    section.dataset.videoTabsInitialized = 'true';

    var sliderEl = section.querySelector('[data-video-slider]');
    var tabsEl = section.querySelector('[data-video-tabs]');
    var contentEl = section.querySelector('[data-video-content]');
    if (!sliderEl) return;

    var wrapperEl = sliderEl.querySelector('.swiper-wrapper');
    var tabs = Array.prototype.slice.call(tabsEl ? tabsEl.querySelectorAll('[data-video-tab]') : []);
    var contentItems = Array.prototype.slice.call(contentEl ? contentEl.querySelectorAll('[data-content-item]') : []);
    var defaultBgColor = section.dataset.defaultBgColor || '';
    var defaultBgImage = section.dataset.defaultBgImage || '';
    var bgLayers = Array.prototype.slice.call(section.querySelectorAll('[data-bg-layer]'));
    var activeBgLayerIndex = 0;
    var currentBgImage = defaultBgImage;

    function setBackgroundImage(url) {
      if (!bgLayers.length || url === currentBgImage) return;
      currentBgImage = url;

      var nextIndex = activeBgLayerIndex === 0 ? 1 : 0;
      var nextLayer = bgLayers[nextIndex];
      var currentLayer = bgLayers[activeBgLayerIndex];

      nextLayer.style.backgroundImage = url ? 'url(' + url + ')' : '';
      nextLayer.classList.add('is-visible');
      currentLayer.classList.remove('is-visible');
      activeBgLayerIndex = nextIndex;
    }

    var slideIds = Array.prototype.map.call(wrapperEl.querySelectorAll('[data-video-slide]'), function (slide) {
      return slide.getAttribute('data-slide-id');
    });

    var middleIndex = Math.floor((slideIds.length - 1) / 2);

    var swiper = new Swiper(sliderEl, {
      centeredSlides: true,
      slideToClickedSlide: true,
      initialSlide: middleIndex,
      slidesPerView: 1.3,
      spaceBetween: 0,
      grabCursor: true,
      speed: 450,
      breakpoints: {
        750: {
          slidesPerView: 2.3,
          spaceBetween: 0,
        },
      },
    });

    function getActiveSlide() {
      // Read the active slide straight off the Swiper instance rather than
      // querying for the .swiper-slide-active class, since that class can
      // lag a frame behind swiper.activeIndex during a drag/swipe, which was
      // causing tabs to highlight the slide being left instead of the one
      // being entered.
      return swiper.slides && swiper.slides[swiper.activeIndex];
    }

    function updateVideos() {
      var activeSlide = getActiveSlide();

      section.querySelectorAll('[data-video-slide]').forEach(function (slide) {
        var video = slide.querySelector('[data-video-el]');
        if (!video) return;

        if (slide === activeSlide) {
          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {});
          }
        } else {
          video.pause();
          video.currentTime = 0;
        }
      });
    }

    function setActive(id) {
      var activeTabName = '';

      tabs.forEach(function (tab) {
        var isActive = tab.dataset.target === id;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        if (isActive) activeTabName = tab.dataset.tabName || '';
      });

      // Broadcast the active tab name so other sections (e.g. NL Slider With
      // Data with "Dynamic Sliders" on) can show the matching group.
      window.nlVideoTabsActiveName = activeTabName;
      document.dispatchEvent(new CustomEvent('nl-video-tabs:change', { detail: { name: activeTabName } }));

      contentItems.forEach(function (item) {
        item.classList.toggle('is-active', item.dataset.slideId === id);
      });

      var activeSlide = getActiveSlide();
      var bgColor = activeSlide ? activeSlide.getAttribute('data-bg-color') : '';
      section.style.backgroundColor = bgColor || defaultBgColor;

      var bgImage = activeSlide ? activeSlide.getAttribute('data-bg-image') : '';
      setBackgroundImage(bgImage || defaultBgImage);
    }

    function handleSlideChange() {
      var activeSlide = getActiveSlide();
      var id = activeSlide ? activeSlide.getAttribute('data-slide-id') : null;
      if (id) setActive(id);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var index = slideIds.indexOf(tab.dataset.target);
        if (index === -1) return;
        swiper.slideTo(index);
      });
    });

    swiper.on('slideChange', handleSlideChange);
    swiper.on('slideChangeTransitionEnd', updateVideos);

    handleSlideChange();
    updateVideos();
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initNewLandingVideoTabsSlider(document);
});

document.addEventListener('shopify:section:load', function (event) {
  initNewLandingVideoTabsSlider(event.target);
});

if (document.readyState === 'complete' || document.readyState === 'interactive') {
  initNewLandingVideoTabsSlider(document);
}
